import { hasPermission, PermissionKey, type PermissionMap, PermissionScope } from "@fitness-app/data-models";

export interface IngredientsAccess {
  /** Edycja wpisu w katalogu — musi odpowiadać polityce UPDATE na public.ingredient. */
  canEdit: boolean;
  /** Zatwierdzanie i kasowanie produktów zgłoszonych z apki klientki. */
  canApprove: boolean;
}

export const getIngredientsAccess = (permissions: PermissionMap): IngredientsAccess => {
  // Zatwierdzanie zawiera w sobie edycję: recenzja produktu z kolejki weryfikacji
  // polega na poprawieniu makro przed akceptacją. To samo ramię `or` siedzi
  // w polityce RLS (20260817120000) — rozjazd dałby przycisk kończący się 403.
  const canApprove = hasPermission(permissions, PermissionKey.NUTRITION_INGREDIENTS_APPROVE, PermissionScope.ALL);
  const canManage = hasPermission(permissions, PermissionKey.NUTRITION_INGREDIENTS_MANAGE, PermissionScope.ALL);

  return {
    canEdit: canManage || canApprove,
    canApprove,
  };
};
